import { render, staticRenderFns } from "./district.vue?vue&type=template&id=bd88f98c&scoped=true"
import script from "./district.vue?vue&type=script&lang=ts"
export * from "./district.vue?vue&type=script&lang=ts"
import style0 from "./district.vue?vue&type=style&index=0&id=bd88f98c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd88f98c",
  null
  
)

export default component.exports